import { type TransformedCartData } from "~/features/cart/cart/transformers/CartViewDataTransformer";
import { trackCartLoad } from "~/app/analytics/ga/ga";

export const CART_LOAD_START = "CartPage: LOAD_DATA_START";
export const CART_LOAD_SUCCESS = "CartPage: LOAD_DATA_SUCCESS";
export const CART_LOAD_FAIL = "CartPage: LOAD_DATA_FAIL";

export function cartLoadStartAction() {
  return {
    type: CART_LOAD_START,
  } as const;
}

export function cartLoadFinishAction(data: TransformedCartData) {
  trackCartLoad(Object.values(data.packEntriesById), data.productByCode);

  return {
    type: CART_LOAD_SUCCESS,
    payload: data,
  } as const;
}

export function cartLoadErrorAction() {
  return {
    type: CART_LOAD_FAIL,
  } as const;
}
